import { render, staticRenderFns } from "./TweetsMenu.vue?vue&type=template&id=084ff95c&"
import script from "./TweetsMenu.vue?vue&type=script&lang=js&"
export * from "./TweetsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports